export default {"src":"/_next/static/image/public/images/flags/flag_58.65cbdeeaa4b23d93500cb303c0f44ab6.svg","height":16,"width":24};